import React from 'react'
import Breadcrumb from '../Components/Breadcrumb'
import Pagehelmet from '../Components/Pagehelmet'
import { Link } from 'react-router-dom'

function Eventlists() {
  return (
    <div>
        <Pagehelmet pageTitle="Event Lists" />
        <Breadcrumb title="Event Lists" />
        

        {/*--Schedules Section start--*/}
        <section className="schedules pb-0">
            <div className="container">
                <div className="schedule-inner">
                <div className="schedule-list-outer text-center">
                    <div className="row align-items-center">
                        <div className="col-lg-3">
                        <div className="schedule-day schedule-day1 text-lg-start py-6 position-relative ps-2 z-1">
                            <h4 className="pink mb-2">1ST DAY</h4>
                            <h6 className="mb-2">APRIL 23, 2024</h6>
                            <p>William Mathew Theater<br/>
                                2390 NW 2nd Ave, Miami, FL 33127</p>
                        </div>        
                        </div>
                        <div className="col-lg-9">
                        <div className="schedule-list  text-center text-sm-start m-sm-0">
                            <div className="row gx-md-5">
                            <div className="col-lg-6 col-md-6">
                                <div className="schedule-list-left">
                                <div className=" schedule-list-box bg-lightgrey   border border-white border-2 rounded px-6 py-4 mb-4">
                                    <div className="schedule-box-title">
                                    <h5 className="mb-2"><Link to="/Eventdetail" className="black">REGISTRATION & BREAKFAST</Link></h5>
                                    </div> 
                                    <div className="schedule-box-info">
                                        <p className="mb-2"><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo, luctus nec ullamcorper mattis, pulvinar dapibus leo.</small></p>
                                        <ul className="mb-2 p-0">
                                        <li className="d-inline"><i className="fa fa-clock-o pink me-2" aria-hidden="true"></i><small>08:30 - 09:30 AM</small></li>
                                        <li className="d-inline"><i className="fa fa-thumb-tack pink mx-2" aria-hidden="true" ></i><small>Exploration Hall</small></li>
                                        </ul>
                                    </div>
                                    <div className="schedule-box-bio d-md-flex">
                                        <div className="schedule-bio-image ">
                                        <img src="assets/images/team/2.jpg" alt="team-image" className="me-2 rounded-circle" />
                                        </div> 
                                        <div className="schedule-bio-info"> 
                                        <p className="mt-1 mb-0"><Link to="/Eventdetail" className="pink">JESUS HOLLAND</Link></p>
                                        <small>Host & Speaker</small>
                                        </div>  
                                    </div>  
                                </div>
                                <div className=" schedule-list-box bg-white border-lightgrey border border-2 rounded px-6 py-4 mb-4">
                                    <div className="schedule-box-title">
                                    <h5 className="mb-2"><Link to="/Eventdetail" className="black">Business Management Info</Link></h5>
                                    </div> 
                                    <div className="schedule-box-info">
                                    <p className="mb-2"><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo, luctus nec ullamcorper mattis, pulvinar dapibus leo.</small></p>
                                    <ul className="mb-2 p-0">
                                        <li className="d-inline"><i className="fa fa-clock-o pink me-2" aria-hidden="true"></i><small>08:30 - 09:30 AM</small></li>
                                        <li className="d-inline"><i className="fa fa-thumb-tack pink mx-2" aria-hidden="true" ></i><small>Exploration Hall</small></li>
                                    </ul>
                                    </div>
                                    <div className="schedule-box-bio d-md-flex">
                                    <div className="schedule-bio-image">
                                        <img src="assets/images/team/3.jpg" alt="team-image" className="me-2 rounded-circle" />
                                    </div> 
                                    <div className="schedule-bio-info"> 
                                        <p className="mt-1 mb-0 pink"><Link to="/Eventdetail" className="pink">NELSON KETY</Link></p>
                                        <small>Host & Speaker</small>
                                    </div>
                                </div>    
                                </div>
                            </div>
                            </div>   
                            <div className="col-lg-6 col-md-6">
                                <div className="schedule-list-left">
                                <div className=" schedule-list-box bg-white border-lightgrey border border-2 rounded px-6 py-4 mb-4">
                                    <div className="schedule-box-title">
                                    <h5 className="mb-2"><Link to="/Eventdetail" className="black">Workshop: Culture & Creativity</Link></h5>
                                    </div> 
                                    <div className="schedule-box-info">
                                    <p className="mb-2"><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo, luctus nec ullamcorper mattis, pulvinar dapibus leo.</small></p>
                                    <ul className="mb-2 p-0">
                                        <li className="d-inline"><i className="fa fa-clock-o pink me-2" aria-hidden="true"></i><small>08:30 - 09:30 AM</small></li>
                                        <li className="d-inline"><i className="fa fa-thumb-tack pink mx-2" aria-hidden="true" ></i><small>Exploration Hall</small></li>
                                    </ul>
                                    </div>
                                    <div className="schedule-box-bio d-md-flex">
                                    <div className="schedule-bio-image">
                                        <img src="assets/images/team/1.jpg" alt="team-image" className="me-2 rounded-circle"/>
                                    </div> 
                                    <div className="schedule-bio-info"> 
                                        <p className="mt-1 mb-0 pink"><Link to="/Eventdetail" className="pink">NELSON KETY</Link></p>
                                        <small>Host & Speaker</small>
                                    </div>
                                    </div>    
                                </div>
                                <div className=" schedule-list-box bg-lightgrey   border border-white border-2 rounded px-6 py-4">
                                    <div className="schedule-box-title">
                                    <h5 className="mb-2"><Link to="/Eventdetail" className="black">Exploration & Approch</Link></h5>
                                    </div> 
                                    <div className="schedule-box-info">
                                        <p className="mb-2"><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo, luctus nec ullamcorper mattis, pulvinar dapibus leo.</small></p>
                                        <ul className="mb-2 p-0">
                                        <li className="d-inline"><i className="fa fa-clock-o pink me-2" aria-hidden="true"></i><small>08:30 - 09:30 AM</small></li>
                                        <li className="d-inline"><i className="fa fa-thumb-tack pink mx-2" aria-hidden="true" ></i><small>Exploration Hall</small></li>
                                        </ul>
                                    </div>
                                    <div className="schedule-box-bio d-md-flex">
                                        <div className="schedule-bio-image ">
                                        <img src="assets/images/team/2.jpg" alt="team-image" className="me-2 rounded-circle"/>
                                        </div> 
                                        <div className="schedule-bio-info"> 
                                        <p className="mt-1 mb-0 pink"> <Link to="/Eventdetail" className="pink">JESUS HOLLAND</Link></p>
                                        <small>Host & Speaker</small>
                                        </div>  
                                    </div>  
                                </div>
                                </div>
                            </div> 
                            </div>    
                        </div>  
                        </div>
                    </div> 
                </div>
                </div>  
            </div> 
        </section>

        <section className="schedule-2 schedules">
            <div className="container">
                <div className="schedule-2-inner w-lg-60 m-auto text-center text-md-start">
                <div className="schedule-2-day pb-4 d-md-flex align-items-center">
                    <div className="schedule-icon">
                    <i className="fa fa-calendar text-grey opacity-25" aria-hidden="true"></i>
                    </div>
                    <div className="schedule-date px-4">
                    <h4 className="pink">2nd DAY</h4>
                    <h6 className="">APRIL 24, 2024</h6>
                    </div>
                    <div className="event-location">
                    <p className="m-0">William Mathew Theater<br/>
                    2390 NW 2nd Ave, Miami, FL 33127</p>
                    </div>  
                </div> 
                <div className="schedule-list">
                    <div className=" schedule-list-box bg-white border-lightgrey border border-2 rounded px-6 py-4 mb-4">
                    <div className="schedule-box-title">
                        <h5 className="mb-2"><Link to="/Eventdetail" className="black">SPEED: MARKETING MASTER!</Link></h5>
                    </div> 
                    <div className="schedule-box-info">
                        <p className="mb-2"><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo, luctus nec ullamcorper mattis, pulvinar dapibus leo.</small></p>
                        <ul className="mb-2 p-0">
                        <li className="d-inline"><i className="fa fa-clock-o pink me-2" aria-hidden="true"></i><small>08:30 - 09:30 AM</small></li>
                        <li className="d-inline"><i className="fa fa-thumb-tack pink mx-2" aria-hidden="true" ></i><small>Exploration Hall</small></li>
                        </ul>
                    </div>
                    <div className="schedule-box-bio d-md-flex ">
                        <div className="schedule-bio-image">
                        <img src="assets/images/team/2.jpg" alt="team-image" className="me-2 rounded-circle"/>
                        </div> 
                        <div className="schedule-bio-info"> 
                        <p className="mt-1 mb-0 pink"><Link to="/Eventdetail" className="pink">NELSON KETY</Link></p>
                        <small>Host & Speaker</small>
                        </div>
                    </div>    
                    </div>
                    <div className=" schedule-list-box bg-lightgrey   border border-white border-2 rounded px-6 py-4 mb-4">
                    <div className="schedule-box-title">
                        <h5 className="mb-2"><Link to="/Eventdetail" className="black">Digital Marketing Theory</Link></h5>
                    </div> 
                    <div className="schedule-box-info">
                        <p className="mb-2"><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo, luctus nec ullamcorper mattis, pulvinar dapibus leo.</small></p>
                        <ul className="mb-2 p-0">
                            <li className="d-inline"><i className="fa fa-clock-o pink me-2" aria-hidden="true"></i><small>08:30 - 09:30 AM</small></li>
                            <li className="d-inline"><i className="fa fa-thumb-tack pink mx-2" aria-hidden="true" ></i><small>Exploration Hall</small></li>
                        </ul>
                    </div>
                        <div className="schedule-box-bio d-md-flex">
                        <div className="schedule-bio-image ">
                            <img src="assets/images/team/3.jpg" alt="team-image" className="me-2 rounded-circle"/>
                        </div> 
                        <div className="schedule-bio-info"> 
                            <p className="mt-1 mb-0 pink"><Link to="/Eventdetail" className="pink">JESUS HOLLAND</Link></p>
                            <small>Host & Speaker</small>
                        </div>  
                    </div>  
                    </div>
                    <div className=" schedule-list-box bg-white border-lightgrey border border-2 rounded px-6 py-4 ">
                    <div className="schedule-box-title">
                        <h5 className="mb-2"><Link to="/Eventdetail" className="black">Global Inovations in Medias</Link></h5>
                    </div> 
                    <div className="schedule-box-info">
                        <p className="mb-2"><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo, luctus nec ullamcorper mattis, pulvinar dapibus leo.</small></p>
                        <ul className="mb-2 p-0">
                        <li className="d-inline"><i className="fa fa-clock-o pink me-2" aria-hidden="true"></i><small>08:30 - 09:30 AM</small></li>
                        <li className="d-inline"><i className="fa fa-thumb-tack pink mx-2" aria-hidden="true" ></i><small>Exploration Hall</small></li>
                        </ul>
                    </div>
                    <div className="schedule-box-bio d-md-flex">
                        <div className="schedule-bio-image">
                        <img src="assets/images/team/1.jpg" alt="team-image" className="me-2 rounded-circle" />
                        </div> 
                        <div className="schedule-bio-info"> 
                        <p className="mt-1 mb-0 pink"><Link to="/Eventdetail" className="pink">NELSON KETY</Link></p>
                        <small>Host & Speaker</small>
                        </div>
                    </div>    
                    </div>
                </div>
                </div>
            </div>
        </section>
        {/*--Schedules Section end--*/}
    </div>
  )
}

export default Eventlists